import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Avatar extends Component {
	static propTypes = {
		decoratorClass: PropTypes.string,
	};
	render() {
		const {
			decoratorClass
		} = this.props;
		return (
			<div className={`login-avatar ${decoratorClass ? decoratorClass : ''}`}>
				<span
					className='login-avatar-fallback'
					aria-hidden='true'>
				</span>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/components/avatar/Avatar.js